import Projectphoto from "../img/Projectphoto.jpg"
import TodoPhoto from "../img/color Change.jpg"
import Menu from "../img/Menu1.jpg"
import "./WorkCardStyles.css"







const ProjectCardData =[
    {
    imgsrc: Projectphoto,
    title: "Portfolio Website Design",
    Text: "This is my First ever project in React Js",
    view: "https://www.dipeshkafle.com.np/" ,
    source: "https://github.com/Dhananjya/Portfolio_web",
},
{
    imgsrc: TodoPhoto,
    title:"To_Do List Design" ,
    Text: "Second Project On React Js",
    view: "https://to-do-list-sigma-plum.vercel.app/",
    source: "https://github.com/Dhananjya/ToDo-List",
},
{
    imgsrc: Menu,
    title:"Responsive Menu design " ,
    Text: "Third Project On React Js",
    view: "https://hotel-menu-umber.vercel.app/",
    source: "https://github.com/Dhananjya/Hotel-Menu",
},
];


export default ProjectCardData;